import { hashString } from "../utils.js";

document.addEventListener("DOMContentLoaded", function () {
	const bar = document.querySelector(".bds-notification-bar");
	const dismissBtn = bar
		? bar.querySelector(".bds-notification-bar__dismiss")
		: null;
	const sessionKey = "bdsNotificationBarDismissedHash";

	if (!bar) return;

	const content = bar.innerHTML.replace(/<button[\s\S]*?<\/button>/, "");
	const contentHash = hashString(content);

	// Only show bar if not dismissed for this hash

	if (sessionStorage.getItem(sessionKey) !== String(contentHash)) {
		bar.classList.add("active");

		// Enable transition after a tick so it doesn't animate on load

		setTimeout(() => {
			bar.classList.add("transition-enabled");
		}, 10);
	}

	// Dismiss button handler

	if (dismissBtn) {
		dismissBtn.addEventListener("click", function () {
			bar.classList.remove("active");

			sessionStorage.setItem(sessionKey, String(contentHash));

			// Remove from DOM after transition

			bar.addEventListener("transitionend", function handler(e) {
				if (e.propertyName === "opacity") {
					bar.removeEventListener("transitionend", handler);

					if (bar.parentNode) bar.parentNode.removeChild(bar);
				}
			});
		});
	}
});
